import { Icon, Tooltip } from '@mairistem/composants';
import { Feature, Menu } from '@mairistem/module';
import _ from 'lodash';

import { MENUS } from '@/constants';
import { showTooltips } from '@/utils';
import { useRegieStore, useRegisseurStore } from '@/zustand';
import { CycleContextProvider } from '../Context';
import Impayes from './Impayes';

// Icône stable (hors rendu) : @mairistem/module ré-enregistre le menu, en fin de liste, dès que
// l'icône change de référence — ce qui arriverait à chaque re-rendu dû aux stores.
const ICON = showTooltips ? (
  <Tooltip
    trigger={<Icon name="calendar times" />}
    message="Relances et impayés"
    position="right center"
  />
) : (
  <Icon name="calendar times" />
);

const MenuImpayes = () => {
  const disabledMenus = useRegieStore((state) => state.disabledMenus);
  const regisseur = useRegisseurStore((state) => state.regisseur);

  return (
    <Menu
      code={MENUS.MENU_IMPAYES}
      name="Relances et impayés"
      icon={ICON}
      path="/impayes"
      // @ts-expect-error
      visible={!_.isNil(regisseur) && !disabledMenus?.impayes}
    >
      <Feature>
        <Feature.Content>
          <CycleContextProvider impayes allAtOnce>
            <Impayes />
          </CycleContextProvider>
        </Feature.Content>
      </Feature>
    </Menu>
  );
};

export default MenuImpayes;
